import { render, staticRenderFns } from "./JobMatching.vue?vue&type=template&id=06a683b8&scoped=true&"
import script from "./JobMatching.vue?vue&type=script&lang=js&"
export * from "./JobMatching.vue?vue&type=script&lang=js&"
import style0 from "./JobMatching.vue?vue&type=style&index=0&id=06a683b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a683b8",
  null
  
)

export default component.exports